export default __webpack_public_path__ + "static/media/background-1771068_1920.b9a7de31.jpg";